var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",class:[{'active':_vm.active},'line-'+_vm.line]},[_c('div',{staticClass:"right"},[_c('div',{staticClass:"title"}),_vm._l((_vm.line),function(item,index){return _c('p',{key:index,staticClass:"line"})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }